var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPicartoTv({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 800,
    height: 800,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 0C7.161 0 0 7.161 0 16s7.161 16 16 16 16-7.161 16-16S24.839 0 16 0zM9.437 5.579h3.708c.313 0 .563.276.563.624v19.595c0 .348-.249.624-.563.624H9.442c-.312 0-.563-.276-.563-.624V6.203c0-.348.251-.624.563-.624zm6.219 0c.156 0 .308.041.437.119.475.276 9.933 5.891 10.745 6.376a.806.806 0 0 1 0 1.385c-.584.348-10.079 5.989-10.765 6.385a.774.774 0 0 1-1.167-.688v-2.411c0-2.287 3.948-2.939 4.531-3.287a.81.81 0 0 0 0-1.391c-.807-.48-4.531-.995-4.531-3.265V6.385c0-.443.333-.807.749-.812z",
    fill: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPicartoTv);
export default __webpack_public_path__ + "static/media/picarto-tv.bd2cd20d916fa9ecaf2a9b03ef769791.svg";
export { ForwardRef as ReactComponent };